module.exports = __webpack_public_path__ + "static/media/1POLICY18.5e32cc09.jpg";